import { Asset } from "expo-asset";
import React from "react";

/**
 * トップの主役画像(Web版)。ここはページの LCP 要素そのもの。
 *
 * react-native-web の <Image> は「背景画像を敷いた <div>」と「代替テキスト用の
 * 透明な <img>」の2枚組で描画する。この作りが Web では3つの実測上の不利を生んでいた。
 *   1. 背景画像は HTML から発見できないので、JS バンドルの実行まで取得が始まらない
 *      (2026-09-06 実測: LCP 6.3秒のうち 3.1秒が読み込み開始待ち)
 *   2. 透明な <img> は width/height も object-fit も持たないため、Lighthouse の
 *      image-aspect-ratio が「表示 412x480 (0.86) / 実体 1600x900 (1.78)」で落ちる
 *   3. 寸法が入らないので、画像の到着でレイアウトがずれる(CLS)
 *
 * そこで Web では素の <img> を1枚だけ描画し、実寸・object-fit・fetchpriority を
 * 明示する。配信は WebP(45KB)で、JPEG(116KB)はネイティブ側が使う。
 * <head> へのプリロードは scripts/build-web.mjs が同じ WebP を指して差し込む。
 */
// react-native-web 0.21 は Image.resolveAssetSource を持たないため expo-asset から解決する
const HERO = Asset.fromModule(require("./assets/spots/momochi-beach.webp"));

export const HERO_ALT = "福岡・百道浜の夕景";
export const HERO_ASSET_BASENAME = "momochi-beach";

const style = {
  position: "absolute",
  left: 0,
  right: 0,
  bottom: 0,
  width: "100%",
  height: 480,
  // 画像の下側(夕景と建物)が見えるように下寄せで切り抜く
  objectFit: "cover",
  objectPosition: "center bottom",
};

export default function HeroImage() {
  return (
    <img
      src={HERO.uri}
      width={HERO.width}
      height={HERO.height}
      alt={HERO_ALT}
      decoding="async"
      fetchpriority="high"
      draggable={false}
      style={style}
    />
  );
}
